import React, { useEffect, useRef } from 'react';
import { motion, useInView, useMotionValue, useTransform, animate } from 'framer-motion';

export function AnimatedCounter({ to, duration = 1.4 }: { to: number; duration?: number }) {
  const ref = useRef<HTMLSpanElement>(null);
  const isInView = useInView(ref, { once: true, margin: '-40px' });
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) => Math.round(latest).toLocaleString());

  useEffect(() => {
    if (!isInView) return;
    const controls = animate(count, to, { duration, ease: 'easeOut' });
    return () => controls.stop();
  }, [isInView, to, duration, count]);

  return <motion.span ref={ref}>{rounded}</motion.span>;
}
